<style>
	.summary-company-select-ul li{
		background: none !important;
		overflow: hidden;
	}
	.summary-company-select-ul li label{
		display: block;
		position: relative;
	}
	.summary-company-select-ul li label input[type="radio"]{
		position: absolute;
		top: -20px;
		right: 15px;
	}
	.summary-company-select-ul li label input[type="radio"]:checked:before{
		content: url(../assets/allorderbill/radio-check.png);
		position: absolute;
		top:28px;
	}
	.summary-filter-p{
		margin: .3em 1em;
	}
</style>
<template>
<div>
<transition name="slide">
	<div v-show="show" class="summary-wrapper">
		<navbar title="货品汇总-选择餐企"></navbar>
		<div class="summary-filter-shell" style="background:none">
			<div v-for = "(restaurantDetail, index) in restaurantDetails">
				<p class="summary-filter-p">{{restaurantDetail.phonetic}}</p>
				<ul class="summary-filter-ul summary-company-select-ul">
					<li @click="selectCompany(restaurantDetail.restaurant_id,restaurantDetail.name)">
						<label>{{restaurantDetail.name}} 
							<input type="radio" name="selectCompany" v-if="selectJudge(restaurantDetail.restaurant_id)" checked>
							<input type="radio" name="selectCompany" v-else>
						</label>
					</li>
				</ul>
			</div>
		</div>
	</div>
</transition>
</div>
</template>
<script>
import NavBar from '../components/NavBar'
export default {
	props: {
		selectedId: String,
		selectedName: String
	},
	data () {
		return {
			show: false,
			restaurantDetails: []
		}
	},
	components: {
		'navbar': NavBar
	},
	created () {
		this.companyLoad()
	},
	methods: {
		selectJudge (val) {
			if (this.selectedId === val) {
				return true
			} else {
				return false
			}
		},
		open () {
			this.show = !this.show
			// window.console.log(this.selectedId + ',' + this.selectedName)
		},
		selectCompany (id, name) {
			this.show = false
			var str = id + '|' + name
			this.$emit('selectCompany', str)
		},
		companyLoad () {
			// 加载餐企明细
			this.$http.get('/cldEdi/business/getRestraurantList').then((response) => {
				if (response.body.result) {
					this.restaurantDetails = response.body.data
					if (response.body.data.length >= 1) {
						this.selectCompany(response.body.data[0].restaurant_id, response.body.data[0].name)
						// this.selectJudge(response.body.data[0].restaurant_id)
					}
					// window.console.log(this.restaurantDetails)
				} else {
					// window.console.log(response.data.message)
				}
			}, (response) => {
				// window.console.log('加载失败')
				return false
			})
		}
	}
}
</script>


// WEBPACK FOOTER //
// CompanySelect.vue?255400a9